import { createAppAsyncThunk } from "@myRedux/createAppAsyncThunk";
import { handleSliceRejectionDefault } from "@myRedux/handleSliceRejection";
import { ApiCallState, ApiCallStatus } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { createSlice } from "@reduxjs/toolkit";
import { getErrorMessage } from "app/error";
import { OAUTHGOOGLECSRFTOKEN, OAUTHREDIRECT } from "app/localStorage";

export interface OAuthResponse {
  redirectUrl: string
}

const initialState = {
  status: ApiCallStatus.Idle,
  value: null
} as ApiCallState<OAuthResponse>;

export class OAuthRequest {
  csrfToken: string;
  oauthCompletionRedirect: string;

  constructor(oauthCompletionRedirect: string) {
    this.csrfToken = crypto.randomUUID();
    this.oauthCompletionRedirect = oauthCompletionRedirect;
  }
}

export const authorizeGoogleUser = createAppAsyncThunk(
  'oauth/google/authorize',
  async (arg: OAuthRequest, thunkAPI) => {
    try {
      const response = await thunkAPI.extra.authClient.get('oauth/google', { headers : { 'x_csrf_token': arg.csrfToken } });
      if (response.hasError()) {
        return thunkAPI.rejectWithValue(response.statusText);
      }
      return response.data;
    }
    catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error));
    }
  }
)

export const authorizeSlice = createSlice({
  name: 'authorizeSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(authorizeGoogleUser.pending, (state, action) => {
        state.status = ApiCallStatus.Loading;
        localStorage[OAUTHGOOGLECSRFTOKEN] = action.meta.arg.csrfToken;
        localStorage[OAUTHREDIRECT] = action.meta.arg.oauthCompletionRedirect;
      })
      .addCase(authorizeGoogleUser.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        state.value = {
          redirectUrl: action.payload
        };
      })
      .addCase(authorizeGoogleUser.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.value = null;
        localStorage.removeItem(OAUTHGOOGLECSRFTOKEN);
        handleSliceRejectionDefault(action);
      });
  },
});

export const selectGoogleAuthorize = (state: RootState) => state.oauth.google.authorize;

export default authorizeSlice.reducer;